import React, { Component } from "react";
import { LoadMerchantInfo, LoadProductIndo } from "./Connection/CallApi";

export default class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: "",
      guid: 0,
      name: "CHICKEN PIZZA",
      Gdesc: "",
      ImageUrl: "",
      data: [],
      URL: "",
      CSP: "",
      STOREURL: "",
    };
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    let p = queryParams.get("p");
    let g = queryParams.get("g");
    let c = queryParams.get("c");

    this.setState({
      page: p,
      guid: g,
      CSP: c,
    });
    this.RenderConnection(p, g, c);
  }
  RenderConnection(PAGE, GUID, CSP) {
    if (PAGE === "P") {
      LoadProductIndo(GUID, CSP).then((response) => {
        let res = JSON.parse(response);

        let objresponse = JSON.parse(res);
        if (objresponse.length > 0) {
          let url = "";
          let STOREURL = "";

          if (CSP === "AV") {
            STOREURL = "https://onelink.to/avasfood";
            url = "avas://avas.io/" + PAGE + "?GUID=" + GUID + "";
          }
          this.setState({
            name: objresponse[0].Description,
            Gdesc: objresponse[0].GDescription,
            ImageUrl: objresponse[0].ProductImageUrl,
            URL: url,
            STOREURL: STOREURL,
          });
          window.location.href = url;
          return null;
        }
      });
    } else if (PAGE === "M") {
      LoadMerchantInfo(GUID, CSP).then((response) => {
        let res = JSON.parse(response);
        console.log(res);
        let objresponse = JSON.parse(res);
        if (objresponse.length > 0) {
          let url = "";
          let STOREURL = "";
          if (CSP === "AV") {
            url = "avas://avas.io/" + PAGE + "?GUID=" + GUID + "";
            STOREURL = "https://onelink.to/avasfood";
          }
          this.setState({
            name: objresponse[0].Merchant,
            Gdesc: objresponse[0].Add1,
            ImageUrl: objresponse[0].ImageURL,
            URL: url,
            STOREURL: STOREURL,
          });
          window.location.href = url;
          return null;
        }
      });
    }
  }
  handleClick() {
    //window.location.replace(this.state.URL);
    window.location.assign(this.state.URL);
  }
  render() {
    return (
      <div>
        <div
          style={{
            height: 450,

            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,

            margin: "auto",
          }}
        >
          <div style={{ justifyContent: "center", alignItems: "center" }}>
            <img
              src={this.state.ImageUrl}
              className="img-responsive"
              alt="about img"
              style={{
                height: 150,
                borderRadius: 20,
                justifyContent: "center",
                alignItems: "center",
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
                width: 150,
              }}
            />
          </div>
          <div
            style={{
              padding: 10,
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center",
            }}
          >
            <h2 style={{ textAlign: "center" }}>{this.state.name}</h2>

            <p style={{ textAlign: "center" }}>{this.state.Gdesc}</p>
            <a
              href={this.state.URL}
              className="btn btn-default"
              style={{
                margin: "auto",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                alignSelf: "center",
                display: "block",
                width: 150,
              }}
            >
              Open with app
            </a>
            <br></br>
            <a
              href={this.state.STOREURL}
              className="btn btn-default"
              style={{
                margin: "auto",
                justifyContent: "center",
                alignContent: "center",
                alignItems: "center",
                alignSelf: "center",
                display: "block",
                width: 150,
              }}
            >
              Get the app
            </a>
          </div>
        </div>
      </div>
    );
  }
}
